'use strict';

angular.module('web2print.recipients')
  .controller('OdrRecipientsCtrl', function (Common, addressCalculationFactory, postalCodesFactory, odrFactory, $scope, recipientsFactory, productsFactory) {
    const vm = this;
    const defaultFilters = odrFactory.defaultFilters;
    const getTargetType = odrFactory.getTargetType;

    function validInputs () {
      return getCurrentFilter().formOfHousing
        && postalCodesFactory.zipcodes
        && postalCodesFactory.zipcodes.length;
    }

    function getCurrentFilter () {
      return vm.filters[getTargetType()];
    }

    function saveChanges () {
      Common.set('recipients.odrFilters', vm.filters);
    }

    function constructODRParams () {
      const filter = getCurrentFilter();
      return {
        formOfHousing: filter.formOfHousing,
      };
    }

    function refreshRefined () {
      const params = constructODRParams();
      params.zipcodes = Common.get('recipients.odrGroup.postalcodes', []);
      params.postalCodeGroups = Common.get('recipients.odrGroup.postalcodeGroup', []);
      saveChanges();
      if (validInputs()) {
        addressCalculationFactory.computeRefinedCount(params);
      }
    }

    function refreshGross () {
      // updates the count when a chip is selected
      const params = constructODRParams();
      params.zipcodes = Common.get('recipients.odrGroup.postalcodes', []);
      params.postalCodeGroups = Common.get('recipients.odrGroup.postalcodeGroup', []);

      saveChanges();

      if (vm.grossCount === 0) {
        addressCalculationFactory.resetCount();
      }

      if (validInputs()) {
        addressCalculationFactory.computeAddressCount(params);
      }
    }

    function activate () {
      console.log('OdrRecipientsCtrl activated');
      vm.grossCount = Common.get('recipients.grossAddressCount', null);
      vm.count = Common.get('recipients.refinedAddressCount', null);
      vm.filters = Common.get('recipients.odrFilters', defaultFilters());
      // methods
      vm.isFetchingRefinedCount = odrFactory.isFetchingRefinedCount;
      vm.isFetchingGrossCount = odrFactory.isFetchingGrossCount;
      vm.formatNumberForSummary = addressCalculationFactory.formatNumberForSummary;
      vm.showError = addressCalculationFactory.showError;
      vm.getTargetType = odrFactory.getTargetType;
      vm.refreshRefined = refreshRefined;
      vm.getCurrentFilter = getCurrentFilter;
      vm.constructODRParams = constructODRParams;
      vm.addressLimit = recipientsFactory.addressLimit;
      vm.formatNumber = Common.formatNumber;

      postalCodesFactory.setPostalCodesSelectedAreas();

      $scope.$on('chipSelected', refreshGross);

      // productsFactory.getFirstDayDeliveryHighTraffic(); // sorry for the long fn name
      refreshGross();
    }

    activate();
  });
